<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part01">
<p class="partName">FLYING LIFE ONE</p>
<div class="partline"><hr/></div>
<p class="partName1"><span class="bold">THE ARMY</span></p>
<p class="yearcontent">1968–1972</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_part01.vue?5f508cd9